import { getTermsValue, resetTerms, setTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';
import { EBuildingElevatorType } from '../../../../api-models/common/json_query';

const ID = 'buildingLiftTypesType' as const;

const LIFT_MAP_VALUE_TO_LABEL: Record<EBuildingElevatorType, string> = {
  [EBuildingElevatorType.Passenger]: 'Пассажирский лифт',
  [EBuildingElevatorType.Service]: 'Грузовой лифт',
  [EBuildingElevatorType.Telpher]: 'Тельфер',
};

export const buildingLiftTypesTypeTagsManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const types = getTermsValue('building_lift_types_type')(jsonQuery);

    if (types === null) {
      return null;
    }

    return types.map(t => ({
      label: LIFT_MAP_VALUE_TO_LABEL[t],
      value: createTagValue(ID, t.toString()),
    }));
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery, removingTagValue }) => {
    const types = getTermsValue('building_lift_types_type')(jsonQuery);

    if (types === null) {
      return jsonQuery;
    }

    const next = types.filter(t => String(t) !== removingTagValue);

    return next.length > 0
      ? setTerms('building_lift_types_type')(jsonQuery)(next)
      : resetTerms(['building_lift_types_type'])(jsonQuery);
  },
};
